export default __webpack_public_path__ + "static/GT-Super-Display-Medium-Italic-a958a70ca6a65599719ad85e0a89fc47.woff2";